import React from 'react';
import { FileUploader } from '../shared/file-uploader';
import getLayerUploadParams from './upload-url';

interface MBTilesProps {
  startUpload: boolean;
  onUploadBegin: () => void;
  onComplete: () => void;
  onError: () => void;
  maxFiles: number;
}

interface Props {
  isNew: boolean;
  fileUploaderProps: MBTilesProps;
  setLayerFile: (key: string, name: string) => void;
  apiToken?: string;
}

const MBTilesLayer: React.FC<Props> = ({
  isNew, fileUploaderProps, setLayerFile, apiToken,
}: Props) => {
  const getPresignedUrl = ({ file }) => getLayerUploadParams({ file, setLayerFile, apiToken });

  if (isNew) {
    return (
      <FileUploader
        {...fileUploaderProps}
        onUploadParams={getPresignedUrl}
        acceptedFileTypes=".mbtiles"
        acceptedFilesName="MBTiles"
      />
    );
  }

  return null;
};

export default MBTilesLayer;
